import Vue from "vue";
import VueRouter from "vue-router";
import MainPage from "../views/MainPage.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/index",   meta: { title: '首页',requiresAuth: false }, component: () => import('@/views/index.vue')  },
  { path: "/login", meta: { requiresAuth: false }, component: () => import('@/views/login.vue') },
  { path: "/register",meta: { requiresAuth: false }, component: () => import('@/views/register.vue') },
  { path: "/artice",   meta: { title: '文章',requiresAuth: false }, component: () => import('@/views/artice.vue')  },
   { path: "/findpassword",   meta: { title: '找回密码',requiresAuth: false }, component: () => import('@/views/findpassword.vue')  },
  {
    path: "/",
    component: MainPage,
    redirect: "/index" ,
    children: [
      { 
        path: "create",
        meta: { title: '创建新方案',requiresAuth: true },
        component: () => import('@/views/create.vue')
      },
       { 
        path: "create2",
        meta: { title: '创建新方案',requiresAuth: true },
        component: () => import('@/views/create2.vue')
      },
      { 
        path: "doc",
        meta: { title: '授权方案',requiresAuth: true },
        component: () => import('@/views/doc.vue')
      },
      { 
        path: "orderlist",
        meta: { title: '我的订单',requiresAuth: true },
        component: () => import('@/views/orderlist.vue')
      },
      { 
        path: "fapiao",
        meta: { title: '发票管理',requiresAuth: true },
        component: () => import('@/views/fapiao.vue')
      },
      { 
        path: "infor",
        meta: { title: '修改个人资料',requiresAuth: true },
        component: () => import('@/views/infor.vue')
      }
      
    ],
  },
];



const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next) => {
  // 检查目标路由是否需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 检查用户是否存有 Token（这里假设有 Token 即为已登录）
    const token = localStorage.getItem('token')
    if (!token) {
      // 如果没有 Token，则跳转到登录页，并携带目标路径，以便登录后回跳
      next({
        path: '/login',
        query: { redirect: to.fullPath } // 将用户本想访问的地址传给登录页
      })
    } else {
      // 有 Token，允许导航
      next()
    }
  } else {
    // 非保护路由，直接放行
    next()
  }
})
export default router;
